import { render, staticRenderFns } from "./card-package.vue?vue&type=template&id=9d4067bc&scoped=true"
import script from "./card-package.vue?vue&type=script&lang=js"
export * from "./card-package.vue?vue&type=script&lang=js"
import style0 from "./card-package.vue?vue&type=style&index=0&id=9d4067bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4067bc",
  null
  
)

export default component.exports